var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Twitter",
    clipPath: "url(#clip0_118_505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.7024 7.07381C26.7481 7.49593 25.7361 7.77316 24.6999 7.89631C25.7921 7.24311 26.6095 6.21508 26.9999 5.00381C25.9749 5.61381 24.8511 6.04131 23.6799 6.27256C22.8931 5.43079 21.8503 4.87252 20.7136 4.68455C19.5768 4.49657 18.4098 4.68943 17.394 5.23313C16.3781 5.77683 15.5704 6.64092 15.0963 7.69106C14.6222 8.74119 14.5083 9.91854 14.7724 11.0401C12.6938 10.9359 10.6603 10.3957 8.80399 9.45464C6.94768 8.51357 5.31004 7.19262 3.99738 5.57756C3.53275 6.37563 3.28858 7.28285 3.28988 8.20631C3.28988 10.0188 4.21238 11.6201 5.61488 12.5576C4.78489 12.5314 3.97317 12.3073 3.24738 11.9038V11.9688C3.24763 13.1759 3.66534 14.3458 4.42969 15.2801C5.19404 16.2144 6.25798 16.8557 7.44113 17.0951C6.67065 17.3039 5.86277 17.3346 5.07863 17.1851C5.41222 18.2241 6.06239 19.1328 6.93812 19.784C7.81385 20.4351 8.87129 20.7961 9.96238 20.8163C8.87798 21.668 7.63635 22.2975 6.30848 22.669C4.98061 23.0405 3.59254 23.1466 2.22363 22.9813C4.61325 24.5181 7.395 25.334 10.2361 25.3313C19.8524 25.3313 25.1111 17.3651 25.1111 10.4563C25.1111 10.2313 25.1049 10.0038 25.0949 9.78131C26.1185 9.04152 27.0019 8.12509 27.7036 7.07506L27.7024 7.07381Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.adbba4a3950d776759a8cb888afe8331.svg";
export { ForwardRef as ReactComponent };